import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Modal, Form, Spinner } from "react-bootstrap";
import axios from "axios";
// import StaffHeader from "./StaffHeader";
import Swal from "sweetalert2";

const ExitPass = () => {
    const [passes, setPasses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ purpose: "" });
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    const authtoken = localStorage.getItem("token");


    const fetchPasses = async () => {
        setLoading(true);
        try {
            const staffId = 44;
            const response = await axios.get(
                `https://api.mirai.healthcare/api/staff-exit-pass/${staffId}`,
                {
                    headers: {
                        "x-auth": authtoken,
                    },
                }
            );
            if (response.data.success) {
                const data = response.data.data;
                setPasses(Array.isArray(data) ? data : [data]);
            }
        } catch (error) {
            console.error("Error fetching passes:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        const data = new FormData();
        data.append("purpose", formData.purpose);

        try {
            const response = await fetch("https://api.mirai.healthcare/api/staff-exit-pass/by-auth", {
                method: "POST",
                headers: {
                    "x-auth": authtoken,
                },
                body: data,
            });

            const result = await response.json();
            if (response.ok) {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Your Exit Gate Pass has been successfully submitted.",
                });
                setShowModal(false);
                fetchPasses();
            } else if (result.message === "Gate pass already exists for today.") {
                Swal.fire({
                    icon: "warning",
                    title: "Warning",
                    text: result.message,
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: result.message || "Failed to submit exit pass.",
                });
            }
        } catch (error) {
            console.error("Error submitting pass:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An error occurred while submitting the pass.",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPasses();
    }, []);

    return (
        <div>
            {/* <StaffHeader /> */}
            
            <div style={{ marginTop: "80px" }}>
                <Container className="mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2>Staff Exit Pass</h2>
                        <Button variant="primary" onClick={() => setShowModal(true)}>
                            Create Pass
                        </Button>
                    </div>

                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" />
                        </div>
                    ) : (
                        <Row>
                            {passes.map((pass) => (
                                <Col md={4} key={pass.id} className="mb-4">
                                    <Card className="shadow-sm border-0 h-100">
                                        <Card.Body>
                                            <Card.Title className="fw-bold">{pass.first_name}</Card.Title>
                                            <Card.Text>
                                                <strong>Purpose:</strong> {pass.purpose}
                                            </Card.Text>
                                            <Card.Text>
                                                <strong>Out Time:</strong> {pass.out_time}
                                            </Card.Text>
                                            <Card.Text>
                                                <strong>In Time:</strong> {pass.in_time}
                                            </Card.Text>
                                            <Button
                                                variant="outline-primary"
                                                onClick={() => setSelectedPhoto(pass.photo)}
                                            >
                                                View Photo
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}

                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Create Exit Pass</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Purpose</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter purpose"
                                        value={formData.purpose}
                                        onChange={(e) => setFormData({ ...formData, purpose: e.target.value })}
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={() => setShowModal(false)}
                                className="me-3"
                            >
                                Close
                            </Button>
                            <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                                {loading ? "Submitting..." : "Submit"}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={!!selectedPhoto} onHide={() => setSelectedPhoto(null)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Photo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center">
                            <img
                                src={selectedPhoto}
                                alt="Staff Photo"
                                style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setSelectedPhoto(null)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
            </div>
        </div>
    );
};

export default ExitPass;